// Minimal toast pub/sub. Avoids pulling in a toast library for ~3 use sites.
// Components subscribe with `useToasts()` (see hooks.ts); anywhere can publish with
// `toast(...)`.

export interface Toast {
  id: number;
  text: string;
  tone: 'info' | 'success' | 'error';
  ttl_ms: number;
}

type Listener = (toasts: Toast[]) => void;

let _next_id = 1;
let _toasts: Toast[] = [];
const _listeners = new Set<Listener>();

function _emit() {
  for (const fn of _listeners) fn(_toasts);
}

export function toast(text: string, tone: Toast['tone'] = 'info', ttl_ms = 2500): number {
  const id = _next_id++;
  _toasts = [..._toasts, { id, text, tone, ttl_ms }];
  _emit();
  setTimeout(() => {
    _toasts = _toasts.filter((t) => t.id !== id);
    _emit();
  }, ttl_ms);
  return id;
}

export function subscribeToasts(fn: Listener): () => void {
  _listeners.add(fn);
  fn(_toasts);
  return () => {
    _listeners.delete(fn);
  };
}
